import { NgClass, NgOptimizedImage } from '@angular/common'
import { Component, effect, input, output, signal } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'dhp-chip-filter',
  templateUrl: './chip-filter.component.html',
  styleUrl: './chip-filter.component.scss',
  imports: [NgClass, NgOptimizedImage, TranslatePipe],
})
export class ChipFilterComponent {
  // Inputs & Outputs
  title = input.required<string>()
  chips = input.required<ChipFilter[], ChipFilter[]>({
    transform: transformChips,
  })
  selectedChip = output<ChipFilter | null>()

  // Internal state
  isOpened = signal<boolean>(false)
  selectedValue = signal<ChipFilter | null>(null)

  constructor() {
    effect(() => {
      this.selectedChip.emit(this.selectedValue())
    })
  }

  toggle(forceToggle?: boolean): void {
    this.isOpened.update(state => forceToggle ?? !state)
  }

  selectChip(chip: ChipFilter): void {
    this.selectedValue.set(chip.value !== null ? chip : null)
    this.toggle(false)
  }
}

function transformChips(chips: ChipFilter[]): ChipFilter[] {
  return [
    {
      label: 'components.filter.all',
      value: null,
    },
    ...chips,
  ]
}

export interface ChipFilter {
  label: string
  value: ChipValue
}

export type ChipValue = string | number | Record<string, unknown> | null
